import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import {get} from "lodash"
import Query from "../Query"
import {questionGroupFieldsFragment} from "../../gql/fragments/questionGroup"
import GetInsGlobal from "../../client/query/insGlobal"
import CreatePrivateQuestionGroup from "../../mutation/wizard/question/CreatePrivateQuestionGroup"

const query = gql`
 query DeletedQuestionGroupWizard ($params: QuestionGroupListParams!) {
    questionGroups(params: $params) {
     results {
        ...questionGroupFields
     }
    }
  }
  ${questionGroupFieldsFragment}
`

const GetDeletedQuestionGroup = ({children, contentId, ...props}) => {
  return (
    <GetInsGlobal>
      {({tenant: tenantUuid}) => {
        const variables = {params: {contentId, tenantUuid}
        }
        return (
          <CreatePrivateQuestionGroup contentId={contentId} refetchQueries={[{query, variables}]}>
            {(create) => {
              return (
                <Query
                  query={query}
                  variables={variables}
                  useLoader={false}
                  {...props}
                  onCompleted={(data) => {
                    const questionGroup = get(data, "questionGroups.results[0]")
                    if (!questionGroup) create()
                  }}>
                  {({data: {questionGroups} = {}, ...apolloState}) => {
                    const questionGroup = get(questionGroups, "results[0]") || {}
                    return children({questionGroup, ...apolloState})
                  }}
                </Query>
              )
            }}
          </CreatePrivateQuestionGroup>
        )
      }}
    </GetInsGlobal>
  )
}

GetDeletedQuestionGroup.propTypes = {
  children: PropTypes.func.isRequired,
  contentId: PropTypes.string
}

GetDeletedQuestionGroup.defaultProps = {
  contentId: "insights.questionGroup.custom.deleted"
}

export default GetDeletedQuestionGroup
